import * as React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const UploadModalFilesHeader: React.FC = () => (
  <TableHeader>
    <TableRow>
      <TableHead className="h-9 w-[58%] px-2.5 text-xs font-semibold uppercase tracking-[0.1em]">File</TableHead>
      <TableHead className="h-9 w-[26%] px-2.5 text-xs font-semibold uppercase tracking-[0.1em]">Phase</TableHead>
      <TableHead className="h-9 w-[16%] px-2.5 text-right text-xs font-semibold uppercase tracking-[0.1em]">
        Progress
      </TableHead>
    </TableRow>
  </TableHeader>
);
